import { IContact } from '@sales-center/common'
import type { LocationOrContact } from '../hooks/useCleanupEntityContacts'

export function sortContactsByFirstNameLastName(
  a: IContact,
  b: IContact,
): number {
  return a.firstName > b.firstName
    ? 1
    : a.firstName == b.firstName
    ? a.lastName > b.lastName
      ? 1
      : -1
    : -1
}

export function sortLocationOrContactByName(
  a: LocationOrContact,
  b: LocationOrContact,
): number {
  return sortContactsByFirstNameLastName(a.data.contact, b.data.contact)
}

export function validateContactForPush(contact: IContact) {
  const errors: string[] = []

  if (contact.firstName && contact.firstName.length > 15)
    errors.push('First name must be between 1 and 15 characters')
  if (contact.lastName && contact.lastName.length > 20)
    errors.push('Last name must be between 1 and 20 characters')
  if (contact.company && contact.company.length > 35)
    errors.push('Company must be between 1 and 35 characters')
  return errors
}
